import { ArrowUp } from "lucide-react";
import { scrollToSection } from "@/lib/api";

export default function Footer({ player }) {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/10 bg-[#070709]"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 py-16 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="font-bebas text-6xl leading-none tracking-wide md:text-7xl">
            BIG CAL <span className="text-neon">#{player.jersey}</span>
          </p>
          <p className="mt-3 font-jbmono text-[10px] uppercase tracking-[0.35em] text-white/40">
            Swing hard · Run fast · Have fun
          </p>
          <p className="mt-1 font-jbmono text-[10px] uppercase tracking-[0.35em] text-white/25">
            {player.team} · {player.positions.join(" / ")}
          </p>
        </div>
        <button
          data-testid="back-to-top-button"
          onClick={() => scrollToSection("#mound")}
          className="group flex w-fit items-center gap-3 rounded-full border border-white/15 px-6 py-3 font-bebas text-lg tracking-widest text-white/70 transition-colors duration-300 hover:border-neon hover:text-neon"
        >
          BACK TO THE MOUND
          <ArrowUp className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-1" />
        </button>
      </div>
    </footer>
  );
}
